import React from 'react';
import RequireLogin from '../RequireLogin';
import Deck from './Deck';

/**
 * Route component for /en/deck (DR-2026-261).
 *
 * Composes the token gate with the deck so the private-by-default posture
 * (DR-2026-258) is enforced on this addonRoute: anonymous → /login, authenticated
 * → the full-screen deck.
 */
const DeckRoute = () => (
  <RequireLogin>
    <Deck />
  </RequireLogin>
);

export default DeckRoute;
